<template>
    <div :class="stickyClassName" :style="stickyStyle">
        <slot />
    </div>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { TopMarginResult, useNavigationStore } from '../../stores/navigation';

export default {
    props: {
        enabled: { type: Boolean, default: true },
        stickyClass: { type: String, default: 'xl:sticky' },
    },
    computed: {
        ...mapState(useNavigationStore, ['additionalTopMarginContent']),
        topMarginContent(): TopMarginResult {
            // Keep title below nav plus extra margin which serves as padding to nav
            return this.additionalTopMarginContent({ prefix: 'top', sm: 0, md: 0, lg: 0, xl: 12 });
        },
        stickyClassName(): string {
            return this.enabled ? `${this.stickyClass} ${this.topMarginContent.class}` : '';
        },
        stickyStyle(): Record<string, string> {
            return this.enabled ? this.topMarginContent.style : {};
        },
    },
};
</script>
